<div [class.c-pricing-table--featured]="activePackage.destaque" *ngIf="activePackage">

  <div *ngIf="activePackage.etiqueta" class="c-pricing-table__flag">
    {{ activePackage.etiqueta }}
  </div>

  <header class="c-pricing-table__header">
    <h3 class="c-pricing-table__title" [innerHTML]="activePackage.nome"></h3>

    <p class="c-pricing-table__credits">
      {{ activePackage.plano }}
    </p>

    <p class="c-pricing-table__usage">{{ activePackage.nomeDetalhe }}</p>
  </header>

  <p class="c-pricing-table__values">
      <span class="c-pricing-table__from">
        <ng-container *ngIf="activePackage.valorSemDesconto; else noDiscount">
          de {{ activePackage.valorSemDesconto | fromCents | currency:'BRL' }}
        </ng-container>

        <ng-template #noDiscount>apenas</ng-template>
      </span>

    <ng-container *ngIf="activePackage.numParcelas > 1; else noInstalments">
      {{ activePackage.valorSemDesconto ? 'por ' : null }}
      {{ activePackage.numParcelas }} x
      {{ activePackage.valorParcela | fromCents | currency:'BRL' }}
    </ng-container>

    <ng-template #noInstalments>
      {{ activePackage.valorSemDesconto ? 'por ' : null }}
      {{ activePackage.valorTotal | fromCents | currency:'BRL' }}
    </ng-template>
  </p>

  <p class="c-pricing-table__content">
    {{ activePackage.descricao }}
  </p>

  <mat-form-field class="c-form__control"
                  [class.t-red1000-dark]="activePackage.destaque"
                  appearance="standard">
    <mat-label>Cupom de desconto</mat-label>
    <input matInput
           [formControl]="couponControl"
           autocomplete="off">
  </mat-form-field>

  <button matRipple
          class="c-button"
          [class.c-button--outline]="!activePackage.destaque"
          [class.c-button--solid-reversed]="activePackage.destaque"
          style="width: 100%"
          (click)="action(activePackage, $event)">
    Compre agora
  </button>
</div>
